import { formatInTimeZone } from "date-fns-tz";
import { GetCalendarItemDetailQuery } from "./CalendarDetail-generated.hooks";
import { createCsvContent } from "../../../utils/csvUtils";

export const source = "Core - class view";

const CLASS_USERS_CSV_HEADER_MAP = {
  name: "name",
  email: "email",
  registrationDate: "registration_date",
  status: "status",
  checkedIn: "checked_in",
  cancelled: "cancelled",
  cancelDate: "cancel_date",
  waitListUntilDate: "waitlist_until_date",
  waitListConvertedDate: "waitlist_converted_date",
};

export function isInviteOnly(
  calendarItem: GetCalendarItemDetailQuery["getCalendarItem"],
) {
  return calendarItem.registrationAccess === "invite_only";
}

export function createClassUsersCsv(
  timezone: string,
  data?: GetCalendarItemDetailQuery["getCalendarItem"]["attendees"],
) {
  if (!data) {
    return "Invalid content";
  }
  const rows = data.map((item) => {
    return {
      name: item.customerName?.replace(/,/g, "").trim(),
      email: item.customerEmail?.trim(),
      registrationDate: formatCsvDate(item.registrationTimestamp, timezone),
      status: item.status,
      checkedIn: item.checkinUuid ? "TRUE" : "FALSE",
      cancelled: item.cancelTimestamp ? "TRUE" : "FALSE",
      cancelDate: formatCsvDate(item.cancelTimestamp, timezone),
      waitListUntilDate: formatCsvDate(item.waitlistUntilTimestamp, timezone),
      waitListConvertedDate: formatCsvDate(
        item.waitlistConvertedTimestamp,
        timezone,
      ),
    };
  });
  return createCsvContent(rows, CLASS_USERS_CSV_HEADER_MAP);
}

function formatCsvDate(timestamp: number, timezone: string) {
  return timestamp
    ? formatInTimeZone(timestamp * 1000, timezone, "MM-dd-yyyy h:mm a")
    : "";
}

export function generateClassUsersFileName(
  timezone: string,
  name?: string,
  startDatetime?: string,
): string {
  if (!name || !startDatetime) {
    return "invalid-class.csv";
  }

  // Replace spaces, underscores, special characters, and forward slashes with dashes
  const trimmedName = name.trim().toLowerCase();
  const dashCaseName = trimmedName.replace(/[\s_\-/]+/g, "-");

  // format start date time
  const date = formatInTimeZone(
    new Date(startDatetime),
    timezone,
    "yyyy-MM-dd-HHmm",
  );

  return `${dashCaseName}-${date}-class-registrations.csv`;
}
